import { useController } from "react-hook-form";
import { StyledCheckBox } from "./checkBox.style";
import { CheckBoxProps } from "./checkBox.type";

export const CheckBox = ({ control, label, name, onChange, isChecked }: CheckBoxProps) => {
    const { field } = control ? useController({ name, control }) : { field: { value: false, onChange: () => {} } };

    return (
        <StyledCheckBox
            isChecked={isChecked !== undefined ? isChecked : field.value}
            onChange={(e) => {
                field.onChange(e.target.checked);

                if (onChange) {
                    onChange(e);
                }
            }}
        >
            {label}
        </StyledCheckBox>
    );
};
